var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIllustrationElec = function SvgIllustrationElec(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9559 61.9186L68.7 63.8099L26.0635 76.5899L38.4127 66.7218L30.7034 64.8379L56.1475 52.5689L72.3948 56.4027L60.9559 61.9186Z",
    fill: "#292929",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7246 4.81327L33.7615 3.21716L34.131 22.0174L29.0941 23.6135L28.7246 4.81327Z",
    fill: "#044D29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50684 9.67131L12.5437 8.0752L33.7611 3.21716L28.7242 4.81327L7.50684 9.67131Z",
    fill: "#00261C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0937 23.6135L39.3292 21.3921L26.2099 76.6366L18.5199 47.7835L8.32962 50.7406L7.50684 9.67127L28.7242 4.81323L29.0937 23.6135ZM26.0778 72.0211L37.6703 23.1217L27.9986 25.2615L27.6291 6.48202L8.65903 10.9818L9.42321 49.0919L19.215 46.1919L26.077 72.0196",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3293 21.3922L44.3662 19.7961L31.2468 75.0405L26.21 76.6366L39.3293 21.3922Z",
    fill: "#044D29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 23.6135L34.1306 22.0174L44.3661 19.7961L39.3293 21.3922L29.0938 23.6135Z",
    fill: "#00261C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0779 72.0211L37.6704 23.1218L27.9988 25.2615L27.6293 6.48206L8.65918 10.9819L9.4241 49.0926L19.2159 46.1926L26.0779 72.0211Z",
    fill: "#0A9828"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81152 18.6227C19.3274 24.7641 27.5586 34.6021 32.1426 46.4391L26.0781 72.0212L19.2158 46.1931L9.42383 49.0925L8.81152 18.6227Z",
    fill: "#16B639"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIllustrationElec);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "illustration_elec.182cfc47b0a7bb5a88e1547cc463846c.svg";